import React from 'react'

import { Heading, LazyImage } from '@offerzen/pinata'

import TermsLinkCard from '../../components/TermsLinkCard'

import styles from './styles'

const TermsLanding = () => (
  <div className={styles.container}>
    <LazyImage loader={() => import('../../../assets/dino-reading.svg')} alt="" width={120} />
    <Heading className={styles.termsHeading}>Terms of use</Heading>
    <p>Find out more about what you can expect from OfferZen&apos;s services
      and what we expect from you when you use our platform.
    </p>
    <TermsLinkCard title="Employer terms of use" buttonLabel="View employer terms" termsLink="/terms/employer" />
    <TermsLinkCard title="Candidate terms of use" buttonLabel="View candidate terms" termsLink="/terms/candidate" />
  </div>
)

export default TermsLanding
